import {ViewType} from "../../../../../core/gd/const/views/view-type"
import ApiProject from "../../../../../core/gd/api/project"

export async function createCustomDashboardWithSetup(viewName: string, dashboardConfig:any, creationParams: any = {}) {

    const params = {
        location    : _.get(creationParams, 'location', 'my-work'),
    }

    const settings = {
        appSettings : dashboardConfig
    }

    let response
    if (creationParams.parentProjectId) {
        const parentProject = gd.session.projects.get(creationParams.parentProjectId)!
        response = await ApiProject.newView({
            name            : viewName,
            color           : parentProject.color,
            parentProjectId : creationParams.parentProjectId,
            projectIcon     : 'view-dashboard',
            settings        : {
                customView      : {
                    settings        : settings,
                    type            : ViewType.CUSTOM_VIEW_DASHBOARD
                }
            }
        }).promise()
        gd.navigation.goToProject(response.projectId)
    } else {
        response = await gd.api.Views.create(
            ViewType.CUSTOM_VIEW_DASHBOARD,
            viewName,
            params,
            0,
            null,
            settings
        ).promise()
        gd.navigation.goToDashboard(response.view.id)
    }


}